






























































import Vue from 'vue'
import EmojiPicker from './../EmojiPicker.vue'

export default Vue.extend({
  components: {
    EmojiPicker
  },
  data: () => ({
    isActive: false
  }),
  props: {
    onEmojiPicked: {
      type: Function,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  methods: {
    _openPicker () {
      this.isActive = !this.isActive
    },
    _handlePickerBlur () {
      this.isActive = false
    }
  }
})
